import { IApplicationState } from '../../types/redux';

export function selectMediaBanksNumber(state: IApplicationState) {
  return state.media.banksNumber;
}
